import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const getDefaultState = () => {
  return {
    created: null,
    cards: null,
    savePaymentMethodState: null,
    savePaymentMethodProgress: false,
    savePaymentMethod3DSChallange: null,
    savePaymentMethodStateCheckCounter: -1,
    savePaymentMethodWaitingAfterChallange: false,
    editPaymentMethodState: null,
    savePaymentMethodErrorMessage: null,
    savePaymentMethodOrderId: null,
    editPaymentMethodProgress: false,
    getAutoTopUpsProgress: false,
    getAutoTopUpsState: null,
    autoTopUps: null,
    autoTopUpProgress: null,
    recurringDetailId: null
  }
}

const state = getDefaultState()

mutations.RESET_STATE = (state) => {
  Object.assign(state, getDefaultState())
}
actions.reset = ({ commit }) => {
  commit('RESET_STATE')
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/wallet/index.js